import React, { useState } from "react";
import { Table, Button, OverlayTrigger, Popover, Form } from "react-bootstrap";
import { apiUrl } from "../../config";
import { Edit, Eye, Trash } from "lucide-react";

const AdvertisementList = ({ ads, onEdit, onDelete, onView, deletingId }) => {
  const [selectedCategoryType, setSelectedCategoryType] = useState("HealthCare Category");
  const viewPopover = (
    <Popover id="popover-view">
      <Popover.Body>View advertisement details</Popover.Body>
    </Popover>
  );
  const editPopover = (
    <Popover id="popover-view">
      <Popover.Body>Edit advertisement details</Popover.Body>
    </Popover>
  );
  const deletePopover = (
    <Popover id="popover-view">
      <Popover.Body>Delete advertisement </Popover.Body>
    </Popover>
  );
  const filteredAds = ads.filter((ad) =>
    ad.category?.toLowerCase().includes(selectedCategoryType.toLowerCase())
  );

  return (
    <>
      {/* <div style={{ marginBottom: "15px", marginLeft: "10px" }}>
        <h5>Category Type</h5>
        <Form.Check
          inline
          label="HealthCare Category"
          type="radio"
          name="categoryType"
          value="HealthCare"
          checked={selectedCategoryType === "HealthCare Category"}
          onChange={(e) => setSelectedCategoryType(e.target.value)}
        />
        <Form.Check
          inline
          label="Community Category"
          type="radio"
          name="categoryType"
          value="Community"
          checked={selectedCategoryType === "Community Category"}
          onChange={(e) => setSelectedCategoryType(e.target.value)}
        />
      </div> */}
      <Table className="custom-employee-table" bordered hover responsive>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Category</th>
            {/* <th>Location</th> */}
            <th>Image</th>
            <th>Title</th>
            {/* <th>PhoneNo1</th> */}
            <th>WebUrl</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {ads.length > 0 ? (
            ads.map((ad, idx) => (
              <tr key={ad.id}>
                <td>{idx + 1}</td>
                <td>{ad.category}</td>
                <td>
                  <img
                    src={apiUrl + "/" + ad.imageUrl}
                    // alt={ad.name}
                    className="student-thumbnail"
                    style={{
                      objectFit: "contain",
                      height: "70px",
                      width: "70px",
                    }}
                  />
                </td>
                <td>
                  {ad.title}
                  <br />
                  {ad.location} <br />
                  {ad.phoneNo1}
                </td>
                {/* <td>{ad.phoneNo1}</td> */}
                <td
                  style={{
                    maxWidth: "200px",
                    textOverflow: "ellipsis",
                    overflow: "hidden"
                  }}
                >
                  {ad.webUrl ? (
                    <a
                      href={ad.webUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      {ad.webUrl}
                    </a>
                  ) : ad.type ? (
                    <a
                      href={apiUrl + "/" + ad.type}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      {ad.type.endsWith(".pdf") ? "View PDF" : ad.type}
                    </a>
                  ) : (
                    "-"
                  )}
                </td>

                <td >
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={viewPopover}
                  >
                    <Button
                      variant="success"
                      // className="btn btn-sm text-white bg-success"
                      style={{
                        backgroundColor: "#10296C",
                        padding: "5px",
                        borderRadius: "5px",
                        marginRight: "5px",
                      }}
                      onClick={() => onView(ad)}
                    >
                      <Eye style={{ width: "20px" }} />
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={editPopover}
                  >
                    <Button
                      size="sm"
                      variant="warning"
                      className="me-1"
                      style={{
                        // backgroundColor: "#10296C",
                        padding: "5px",
                        borderRadius: "5px",
                        marginRight: "5px",
                      }}
                      onClick={() => onEdit(ad)}
                    >
                      <Edit style={{ width: "20px" }} />
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={deletePopover}
                  >
                    <Button
                      size="sm"
                      variant="danger"
                      style={{
                        // backgroundColor: "#10296C",
                        padding: "5px",
                        borderRadius: "5px",
                        marginRight: "5px",
                      }}
                      onClick={() => onDelete(ad.id)}
                      disabled={ad.id === deletingId}
                    >
                      {ad.id === deletingId ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Deleting...
                        </>
                      ) : (
                        <Trash />
                      )}
                    </Button>
                  </OverlayTrigger>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">
                No advertisements found.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>

  );
};

export default AdvertisementList;
